import { getAxiosClient } from "src/utils/axios";

export const getStores =
  ({ userId }) =>
  async (dispatch) => {
    const cli = getAxiosClient("storesList");
    try {
      const res = await cli.get(`/${userId}/branch?page=1&size=100`);
      return res.data;
    } catch (e) {
      console.log(e);
    }
  };
